// extracted by mini-css-extract-plugin
export default {"error":"authError_error__J73xw"};